<template>
  <div class="cruds_wrapper">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "DriverWithdrawalRequestsHome",
};
</script>
